module.exports = __webpack_public_path__ + "img/main-video-thumbnail.07b555a1.png";